<template>
  <div
    v-bind:style="this.styleObject"
  >
    <a
      v-if="devices.length > 1"
      @click="switchDevice"
      class="device-switcher icon yule-icon-refresh btn btn-rounded"
    />
    <video
      v-if='this.streamIsPresent'
      ref="video"
      :width="this.width"
      :height="this.height"
      :srcObject.prop="this.stream"
      :autoplay="this.autoplay"
    />
  </div>
</template>

<script>
export default {
    data () {
      return {
        video: '',
        src: '',
        stream: undefined,
        deviceIndex: -1,
        devices: [],
        hasUserMedia: false,
        facingModes: ['environment', 'back'],
        currentFacingMode: 0,
        styleObject: {
          minWidth: "0px",
          minHeight: "0px"
        }
      }
    },
    props: {
      autoplay: {
        type: Boolean,
        default: true
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 300
      },
      mirror: {
        type: Boolean,
        default: true
      },
      screenshotFormat: {
        type: String,
        default: 'image/jpeg'
      }
    },
    computed: {
      streamIsPresent() {
        return typeof this.stream == 'object'
      },
    },
    mounted() {
      this.video = this.$refs.video;
      this.listVideoMedia()
    },
    beforeDestroy: function () {
      if (this.video) {
        this.video.pause();
      }
      this.src = '';
      this.stopRecording()
    },
    methods: {
      displayDevice(deviceId){
        let config = {
          deviceId: deviceId,
          facingMode: this.facingModes[this.currentFacingMode],
          video: true,
          audio: false
        }
        this.closeStream()
        navigator.mediaDevices.getUserMedia({ video: config }).then((stream) => {
          this.stream       = stream
          // We have to set the min size of the wrapper div the first time the stream loads.
          // This is to prevent the div from resizing when switching between cameras.
          this.$nextTick(function(e) {
            this.$refs.video.addEventListener("loadedmetadata", function (e) {
              this.setMinSizes()
            }.bind(this), false );
          })
          this.hasUserMedia = true
        }).catch((err) => {
          console.log(err)
        })
      },
      // We set the min size of the wrapper to prevent it from resizing when we switch streams (fx when switching front->back camera)
      setMinSizes() {
        // Only set them once
        if (this.styleObject.minHeight === '0px' && this.styleObject.minWidth === '0px') {
          this.styleObject = {
             minHeight: this.$refs.video.clientHeight+"px",
             minWidth: this.$refs.video.clientWidth+"px"
          }
        }
      },
      stopRecording() {
        this.$nextTick(() => {
          this.closeStream()
          this.stream = undefined
        })
      },
      switchDevice(){
        let index = this.deviceIndex
        this.changeFacingMode()
        if(this.devices[index + 1] !== undefined){
          this.displayDevice(this.devices[index+1].deviceId)
          this.deviceIndex = index + 1
        }else{
          this.displayDevice(this.devices[0].deviceId)
          this.deviceIndex = 0
        }
      },
      closeStream() {
        if (this.streamIsPresent) {
          this.stream.getTracks().forEach(track => track.stop())
        }
      },
      changeFacingMode() {
        this.currentFacingMode = this.currentFacingMode == 0 ? 1 : 0
      },
      changeDevice(deviceId){
        this.displayDevice(deviceId)
      },
      listVideoMedia() {
        navigator.mediaDevices.enumerateDevices().then(devices => {
          this.devices = _.filter(devices,{kind:"videoinput"})
          this.devices.forEach((device) => {
            if (device.label.includes('back')) {
              this.displayDevice(device)
              this.deviceIndex = this.devices.indexOf(device)
            }
          })
          // Fallback
          if (this.deviceIndex == -1) {
            this.displayDevice(this.devices[0])
            this.currentFacingMode = 1
            this.deviceIndex       = 0
          }
        })
      },
      getPhoto () {
        if (!this.hasUserMedia) return null;
        const canvas = this.getCanvas();
        return canvas.toDataURL(this.screenshotFormat);
      },
      getCanvas () {
        if (!this.hasUserMedia) return null;
        const video = this.$refs.video;
        if (!this.ctx) {
          const canvas = document.createElement('canvas');
          canvas.height = video.clientHeight;
          canvas.width = video.clientWidth;
          this.canvas = canvas;
          this.ctx = canvas.getContext('2d');
        }
        const { ctx, canvas } = this;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas;
      }
    }
}
</script>
<style lang="scss">
.device-switcher{
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 5;
  background: #fff;
  padding: 0;
  width: 40px;
  text-align: center;
  line-height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// VueWebcam.vue?28e6415b